import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import moment from "moment"
import { flatMap, sample } from "lodash"

import EventGroup from "../event-group"
import countries from "../../helpers/countries"
import EventsConfig from "../../helpers/eventsConfig"
import storyblokLinkHandler from "../../helpers/storyblokLinkHandler"

class EventsPromo extends Component {
  state = {
    events: [],
    eventTypes: [],
    countryCode: [],
    programs: [],
    eventData: [],
  }

  async componentDidMount() {
    const { country, eventType, program, useUsersLocation } = this.props.blok
    const location = useUsersLocation ? ["get_location"] : country
    const search = await this.search(
      this.filterHandler(
        location,
        program,
        eventType.map((type) => (type === "One-to-One" ? "121" : type))
      ),
      this.props.eventsConfig
    )

    return this.setState({
      events: search.events,
      countryCode: search.userLocation ? search.userLocation : country,
      eventTypes: eventType,
      programs: program,
    })
  }

  search = (filters, eventsConfig) => {
    this.page += 1

    return fetch(`${process.env.GATSBY_HULTEDUDATA_API}/events/search`, {
      method: "POST",
      body: JSON.stringify({
        size: 6,
        filters,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.status >= 400) {
          throw new Error("Bad response from server")
        }

        return res.json()
      })
      .then((result) => ({
        events: flatMap(result.hits.hits, (f) => f._source).map(
          (event, index) =>
            event && {
              date:
                moment
                  .utc(event.StartDatetime)
                  .format("llll")
                  .split(" ")
                  .slice(0, -2)
                  .join(" ") || "",
              url: event.Link,
              name: event.Title,
              location:
                event.Region === "Global"
                  ? "Available Worldwide"
                  : countries[event.Country],
              image: this.imgHandler(event, eventsConfig),
              tags: this.programTagHandler(event.Programs),
            }
        ),
        userLocation: [result.location] || "",
      }))
      .catch((err) => {
        console.error(err)
      })
  }

  imgHandler = (event, eventsConfig) => {
    const { specifyEventImage, eventTypeImages } = eventsConfig
    const { Type, Id } = event
    const eventType = Type === "121" ? "One-to-One" : Type
    const eventId = Id.split("-")[0]
    const { img } = eventTypeImages.filter(
      (imgType) => eventType.toLowerCase() === imgType.type.toLowerCase()
    )[0]
    const specImg =
      specifyEventImage.filter((img) => img.eventId === eventId) || []

    if (specImg.length > 0) {
      return sample(specImg).image
    }
    return sample(img).image
  }

  filterHandler = (userCountryCode, programs, types) => {
    const countryFilter = { field: "Country", options: userCountryCode }
    const programFilter = { field: "Programs", options: programs }
    const typeFilter = { field: "Type", options: types }

    let filters = []

    userCountryCode && userCountryCode.length > 0 && filters.push(countryFilter)
    programs && programs.length > 0 && filters.push(programFilter)
    types && types.length > 0 && filters.push(typeFilter)
    return filters
  }

  programTagHandler = (programArr) => {
    return programArr.map((code) => {
      const programArr = this.props.eventsConfig.programList.filter(
        (listProg) => code === listProg.value
      )
      return programArr.length === 1 ? programArr[0].name : ""
    })
  }

  hrefHandler = () => {
    const { countryCode, programs, eventTypes } = this.state

    let paramsArr = []

    eventTypes.length > 0 &&
      paramsArr.push(`eventtype=${this.formatParams(eventTypes)}`)

    programs.length > 0 &&
      paramsArr.push(
        `program=${this.formatParams(this.programCodeToName(programs))}`
      )

    countryCode.length > 0 &&
      paramsArr.push(
        `country=${this.formatParams(this.countryCodeToName(countryCode))}`
      )
    return paramsArr.length > 0 ? `?${paramsArr.join("&")}` : ""
  }

  formatParams = (arr) => arr.join(",").replace(/\s/g, "%20")

  countryCodeToName = (codeArr) => codeArr.map((code) => countries[code])

  programCodeToName = (programArr) => {
    return programArr.map((code) => {
      const programArr = this.props.eventsConfig.programList.filter(
        (listProg) => code === listProg.value
      )
      return programArr.length === 1 ? programArr[0].name : ""
    })
  }

  render() {
    const { blok } = this.props
    const { events } = this.state

    const { eventsResultsUrl } = this.props.eventsConfig

    return (
      <SbEditable content={blok}>
        <div className={`events-promo ${this.props.className}`}>
          <EventGroup
            hide_cta={blok.hide_cta}
            className="event-group--carousel"
            eventArr={events}
            url={`${storyblokLinkHandler(
              eventsResultsUrl
            )}${this.hrefHandler()}`}
          />
        </div>
      </SbEditable>
    )
  }
}

EventsPromo.defaultProps = {
  className: "",
}

EventsPromo.propTypes = {
  blok: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object),
    size: PropTypes.string,
    alignment: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
}

export default EventsConfig(EventsPromo)
